import { useMemo } from 'react';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { parseExcludedIntegrationsFlag } from '~/utils/parseExcludedIntegrationsFlag';

export const useExcludedIntegrationsFlag = () => {
  const { excludedIntegrations: excludedIntegrationsFlag } = useFeatureFlags();

  return useMemo(() => parseExcludedIntegrationsFlag(excludedIntegrationsFlag), [excludedIntegrationsFlag]);
};
